// メニューから問い合わせへ移る間も、背景の停止と戻り先を引き継ぐ。
export function initDialogs(entries, { onOpen, onClose, reducedMotion, timers = globalThis, getSelection = () => globalThis.getSelection?.() }) {
  let active;
  const closing = new Map();
  const cleanups = [];
  const listen = (element, type, handler) => {
    element.addEventListener(type, handler);
    cleanups.push(() => element.removeEventListener(type, handler));
  };
  const release = (dialog) => {
    if (active?.dialog !== dialog || dialog.open) return;
    const { opener } = active;
    active = undefined;
    onClose();
    opener.focus({ preventScroll: true });
  };
  const finishClose = (dialog) => {
    const state = closing.get(dialog);
    if (!state) return;
    closing.delete(dialog);
    timers.clearTimeout(state.timer);
    dialog.close();
    dialog.classList.remove('is-dialog-closing');
    release(dialog);
    state.afterClose?.();
  };
  const close = (dialog, afterClose) => {
    if (!dialog.open || closing.has(dialog)) return;
    const state = { afterClose };
    closing.set(dialog, state);
    if (reducedMotion.matches) {
      finishClose(dialog);
      return;
    }
    dialog.classList.add('is-dialog-closing');
    // アニメーション通知が届かない環境でも、操作不能なモーダルを残さない。
    state.timer = timers.setTimeout(() => finishClose(dialog), 1000);
  };
  const closeOnClick = (dialog, afterClose) => {
    const selection = getSelection();
    // 選択ドラッグ後のclickを、リンクや背景による終了として扱わない。
    if (selection && !selection.isCollapsed
      && (dialog.contains(selection.anchorNode) || dialog.contains(selection.focusNode))) return;
    close(dialog, afterClose);
  };

  entries.forEach(({ dialog, buttons }) => {
    let pressedOutside = false;
    const isOutside = (event) => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right
        || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    buttons.forEach((button) => {
      listen(button, 'click', () => {
        if (dialog.open || closing.size) return;
        const previous = active;
        active = { dialog, opener: previous?.opener ?? button };
        const show = () => {
          dialog.showModal();
          onOpen();
        };
        if (previous) close(previous.dialog, show);
        else show();
      });
    });
    listen(dialog.querySelector('.close'), 'click', () => close(dialog));
    listen(dialog, 'pointerdown', (event) => {
      pressedOutside = event.button === 0 && event.target === dialog && isOutside(event);
    });
    listen(dialog, 'pointercancel', () => { pressedOutside = false; });
    listen(dialog, 'click', (event) => {
      const backdropClick = pressedOutside && event.target === dialog && isOutside(event);
      pressedOutside = false;
      if (backdropClick) closeOnClick(dialog);
    });
    listen(dialog, 'cancel', (event) => {
      event.preventDefault();
      close(dialog);
    });
    const onAnimation = (event) => {
      if (event.target === dialog && event.animationName === 'area_inset_out') finishClose(dialog);
    };
    listen(dialog, 'animationend', onAnimation);
    listen(dialog, 'animationcancel', onAnimation);
    listen(dialog, 'close', () => {
      // 切り替え元の遅延close通知では、新しいモーダルを解除しない。
      if (dialog.open) return;
      if (closing.has(dialog)) finishClose(dialog);
      else release(dialog);
    });
  });
  listen(reducedMotion, 'change', () => {
    if (reducedMotion.matches) for (const dialog of closing.keys()) finishClose(dialog);
  });

  const destroy = () => {
    cleanups.forEach((cleanup) => cleanup());
    for (const [dialog, state] of closing) {
      timers.clearTimeout(state.timer);
      dialog.close();
      dialog.classList.remove('is-dialog-closing');
    }
    closing.clear();
    if (active) {
      active.dialog.close();
      active = undefined;
      onClose();
    }
  };
  return { close, closeOnClick, destroy };
}
